/* eslint-disable */
import Header from "components/Common/Header/Header";
import ProductCategoriesBody from "components/MarketplaceComponents/ProductComponents/ProductDetails/ProductCategories/ProductCategoriesBody";
import { useEffect } from "react";

const ProductCategories = () => {
  useEffect(() => {
    document.title = "Marketplace";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="marketplace" />
      <ProductCategoriesBody />
    </main>
  );
};

export default ProductCategories;
